export const METRIKA_COUNTER_ID = 109273174

export const METRIKA_GOALS = {
  quiz_start: 'quiz_start',
  quiz_step: 'quiz_step',
  lead_submit: 'lead_submit',
  contact_click: 'contact_click',
  demo_request: 'demo_request',
}

/** Legacy CRM goals (доп. слой на переходный период). */
export const CRM_METRIKA_EVENTS = new Set([
  'NEW_BETA_LEAD',
  'QUIZ_STEP',
  'QUIZ_COMPLETED',
  'BETA_REGISTERED',
  'ACTIVE_BETA',
])

export const METRIKA_SKIP_EVENTS = new Set(['SESSION_HEARTBEAT'])

export function reachMetrikaGoal(goalName) {
  if (typeof window === 'undefined' || typeof window.ym !== 'function') return
  try {
    window.ym(METRIKA_COUNTER_ID, 'reachGoal', goalName)
  } catch {
    /* ignore */
  }
}

export function trackSalesMetrikaGoal(goalKey) {
  const name = METRIKA_GOALS[goalKey] || goalKey
  reachMetrikaGoal(name)
}

export function trackCrmMetrikaGoal(eventType) {
  if (METRIKA_SKIP_EVENTS.has(eventType)) return
  if (!CRM_METRIKA_EVENTS.has(eventType)) return
  reachMetrikaGoal(`crm_${eventType}`)
}

export function flushMetrikaBeforeNavigate(ms = 120) {
  if (typeof window === 'undefined') return Promise.resolve()
  return new Promise((resolve) => {
    window.setTimeout(resolve, ms)
  })
}
